const getFontPreference = (inheritedFont: string) => {
  const pluginFonts = [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Open Sans",
    "Helvetica Neue",
    "sans-serif",
  ];

  let orderedArray: string[] = [...pluginFonts];

  pluginFonts.map((font) => {
    if (font === inheritedFont) {
      orderedArray = orderedArray.filter((item) => item !== font);
      orderedArray.unshift(font);
    }
  });

  return orderedArray.toString();
};

export default getFontPreference;
